import {
  FormControl,
  MenuItem,
  InputLabel,
  Select,
  Stack,
} from "@mui/material";
import { DocumentType } from "generated-graphql/graphql";
import { documentTypeToLabel } from "util/constants";

type FacilityDocumentTypePickerProps = {
  documentTypes: DocumentType[];
  selectedDocumentType?: DocumentType;
  onSelectDocumentType?: (documentType: DocumentType) => void;
};

export const FacilityDocumentTypePicker = ({
  documentTypes,
  selectedDocumentType,
  onSelectDocumentType,
}: FacilityDocumentTypePickerProps) => {
  return (
    <Stack spacing={1}>
      <FormControl>
        <InputLabel id="select-document-type-label">Document Type *</InputLabel>
        <Select
          value={selectedDocumentType ?? ""}
          labelId="select-document-type-label"
          label="Document Type"
          onChange={(e) => {
            onSelectDocumentType?.(e.target.value as DocumentType);
          }}
        >
          {documentTypes.map((type) => (
            <MenuItem key={type} value={type}>
              {documentTypeToLabel(type)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
};
